import { DIVISION } from "core/interfaces";

export const getDivisionCategoryOptions = () => {
	const { t } = useI18n();

	return Object.values(DIVISION).map(value => ({
		id: value,
		name: t(`COMMON.${value}`)
	}));
};
